import { useState, useEffect } from "react";
import { IconStar } from "../common/icon"
import { HeaderBack } from '@/components/common/header';
import _ from "lodash";
import { Textarea } from "@mantine/core";
import { useForm } from "@mantine/form";
import { getCookie } from "cookies-next";
import { _modelName } from "../../libraries/common";
import { TyreImage } from "../common/image";
import { _postURL } from "../../pages/api";
import { toast } from "@/libraries/swal";
import { useRouter } from "next/router";
import { MyBody } from "../body/body";

export const TyreWriteReview = (props) =>{
    const { t, device, session, params, fetchedData } = props
    const [seletedStar, setSelectedStar] = useState(5)
    const [selectedDryGrip, setSelectedDryGrip] = useState(5)
    const [selectedWetGrip, setSelectedWetGrip] = useState(5)
    const [selectedLongevity, setSelectedLongevity] = useState(5)
    const [selectedSilenceComfort, setSelectedSilenceComfort] = useState(5)
    const [userData, setUserData] = useState({});
    const router = useRouter()

    const { getInputProps, onSubmit, isValid, values, setFieldError, reset, setFieldValue, clearFieldError } = useForm({
        validateInputOnChange: true,
        initialValues: {
            review: '',
        },
        validate: {
            review: (inputValue) => inputValue.length <= 0 && "Review Cannot Be Empty",
        }
    });

    const _subimtReview = async(value) => {
        try{
            if(_.isEmpty(userData)){
                throw ("You haven't login")
            }
            let req = {
                "review": value.review,
                "rating": seletedStar,
                "drygrip_braking": selectedDryGrip,
                "wetgrip_braking": selectedWetGrip,
                "longevity": selectedLongevity,
                "silence_comfort": selectedSilenceComfort,
                "tyre_model_id": fetchedData?.tyre_model_id,
            }
            const response = await _postURL("/api/review/createUserTyreReview", {...req});

            if(!_.isEmpty(response)){
                await toast.success("Create user review succesful")
                router.push(router.query.tyre[0] + "/" + router.query.tyre[1] + "/review")
            }

        } catch (error) {
            toast.error(error)
        }
    }

    useEffect(() => {
        let user = getCookie("user") && JSON.parse(getCookie("user"));
        setUserData(user);
    }, []);

    return (
        <>
            <MyBody
                t={t}
                headerComponent={
                    <HeaderBack t={t} />
                }
            >
                <form onSubmit={onSubmit((values) => _subimtReview(values))} className="vehicleWriteReviewPage containerPadding">
                    <div className="vehicleWriteReviewPage_header">
                        <div className="vehicleWriteReviewPage_headerVehicle">
                            <div className="vehicleWriteReviewPage_headerVehicle_imageOuter">
                                <TyreImage 
                                    imagePath={fetchedData?.image_path}
                                />
                            </div>
                            <div className="">
                                <p className="fontSize_14 fontColor_lightBlue2">
                                    {fetchedData?.brand_name}
                                </p>
                                <p className="fontSize_14 fontWeight_semiBold">
                                    {_modelName(fetchedData?.brand_name, fetchedData?.name)}
                                </p>
                                <p className="fontSize_12 fontColor_lightBlue2">
                                    {`${fetchedData?.body_type} | ${fetchedData?.available_inches_string}`}
                                </p>
                            </div>
                        </div>
                        <div className="vehicleWriteReviewPage_rating">
                            <p className="fontSize_14 fontWeight_bold">
                                {t('ratings')}
                            </p>
                            <div className="vehicleWriteReviewPage_rating_starList">
                                {
                                    _.reduce([1,2,3,4,5], (result, value, key)=>{
                                        result.push(
                                            <div key={key} onClick={()=>{setSelectedStar(value)}} className="vehicleWriteReviewPage_rating_starIcon cursorPointer">
                                                <IconStar color={value <= seletedStar ? "#FFC327" : undefined} />
                                            </div>
                                        )
                                        return result
                                    },[])
                                }
                            </div>
                        </div>
                        <div className="vehicleWriteReviewPage_rating tyreWriteReview_extra">
                            <div className="tyreWriteReview_inner">
                                <div className="tyreWriteReview_grid">
                                    <div className="tyreWriteReview_grid_inner">
                                        <span className="fontSize_12 fontWeight_medium">Dry grip and braking</span>
                                        <span style={{ display: 'flex' }}>
                                            {
                                                _.reduce([1,2,3,4,5], (result1, value1, key1)=>{
                                                    result1.push(
                                                        <div key={key1} onClick={()=>{setSelectedDryGrip(value1)}} className="vehicleWriteReviewPage_rating_starIcon cursorPointer tyreWriteReview_rating_star">
                                                            <IconStar color={value1 <= selectedDryGrip ? "#FFC327" : undefined} />
                                                        </div>
                                                    )
                                                    return result1
                                                },[])
                                            }
                                        </span>
                                    </div>
                                    <div className="tyreWriteReview_grid_inner">
                                        <span className="fontSize_12 fontWeight_medium">Wet grip and braking</span>
                                        <span style={{ display: 'flex' }}>
                                            {
                                                _.reduce([1,2,3,4,5], (result2, value2, key2)=>{
                                                    result2.push(
                                                        <div key={key2} onClick={()=>{setSelectedWetGrip(value2)}} className="vehicleWriteReviewPage_rating_starIcon cursorPointer tyreWriteReview_rating_star">
                                                            <IconStar color={value2 <= selectedWetGrip ? "#FFC327" : undefined} />
                                                        </div>
                                                    )
                                                    return result2
                                                },[])
                                            }
                                        </span>
                                    </div>
                                </div>
                                <div className="tyreWriteReview_grid">
                                    <div className="tyreWriteReview_grid_inner">
                                        <span className="fontSize_12 fontWeight_medium">Longevity</span>
                                        <span style={{ display: 'flex' }}>
                                            {
                                                _.reduce([1,2,3,4,5], (result3, value3, key3)=>{
                                                    result3.push(
                                                        <div key={key3} onClick={()=>{setSelectedLongevity(value3)}} className="vehicleWriteReviewPage_rating_starIcon cursorPointer tyreWriteReview_rating_star">
                                                            <IconStar color={value3 <= selectedLongevity ? "#FFC327" : undefined} />
                                                        </div>
                                                    )
                                                    return result3
                                                },[])
                                            }
                                        </span>
                                    </div>
                                    <div className="tyreWriteReview_grid_inner">
                                        <span className="fontSize_12 fontWeight_medium">Silence and Comfort</span>
                                        <span style={{ display: 'flex' }}>
                                            {
                                                _.reduce([1,2,3,4,5], (result4, value4, key4)=>{
                                                    result4.push(
                                                        <div key={key4} onClick={()=>{setSelectedSilenceComfort(value4)}} className="vehicleWriteReviewPage_rating_starIcon cursorPointer tyreWriteReview_rating_star">
                                                            <IconStar color={value4 <= selectedSilenceComfort ? "#FFC327" : undefined} />
                                                        </div>
                                                    )
                                                    return result4
                                                },[])
                                            }
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="vehicleWriteReviewPage_writeReviewContainer">
                        <p className="fontSize_14 fontWeight_bold">
                            {t('write_a_review')}
                        </p>
                        <div className="vehicleWriteReviewPage_textareaContainer"> 
                            <Textarea 
                                minRows={7}
                                maxRows={7}
                                maxLength={100}
                                placeholder={t('what_do_you_think_of_the_quality_and_appearance')}
                                classNames={{
                                    input: "vehicleWriteReviewPage_textarea_input fontSize_14",
                                    error: "fontSize_14 fontColor_red"
                                }}
                                {...getInputProps('review')}
                            />
                            <div className="vehicleWriteReviewPage_textarea_totalNumBox">
                                <p className="fontSize_14 fontColor_lightGrey3">
                                    {`${values?.review.length} / 100`}
                                </p>
                            </div>
                        </div>
                    </div>
                    <button type="submit" disabled={isValid() ? false : true} className="vehicleWriteReviewPage_submitButton primaryButtonBackground">
                        <p className="fontSize_16 fontWeight_bold fontColor_white">
                            {t('submit')}
                        </p>
                    </button>
                </form>
            </MyBody>
        </>
    )

    // return (
    //     <>
    //         <div className='bodyContainer'>
    //             <div className='contentContainer'>
    //                 <HeaderBack t={t} />
    //                 <form onSubmit={onSubmit((values) => _subimtReview(values))} className="vehicleWriteReviewPage containerPadding">
    //                     <div className="vehicleWriteReviewPage_header">
    //                         <div className="vehicleWriteReviewPage_headerVehicle">
    //                             <div className="vehicleWriteReviewPage_headerVehicle_imageOuter">
    //                                 <TyreImage 
    //                                     imagePath={fetchedData?.image_path}
    //                                 />
    //                             </div>
    //                             <div className="">
    //                                 <p className="fontSize_14 fontColor_lightBlue2">
    //                                     {fetchedData?.brand_name}
    //                                 </p>
    //                                 <p className="fontSize_14 fontWeight_semiBold">
    //                                     {_modelName(fetchedData?.brand_name, fetchedData?.name)}
    //                                 </p>
    //                                 <p className="fontSize_12 fontColor_lightBlue2">
    //                                     {`${fetchedData?.body_type} | ${fetchedData?.available_inches_string}`}
    //                                 </p>
    //                             </div>
    //                         </div>
    //                         <div className="vehicleWriteReviewPage_rating">
    //                             <p className="fontSize_14 fontWeight_bold">
    //                                 {t('ratings')}
    //                             </p>
    //                             <div className="vehicleWriteReviewPage_rating_starList">
    //                                 {
    //                                     _.reduce([1,2,3,4,5], (result, value, key)=>{
    //                                         result.push(
    //                                             <div key={key} onClick={()=>{setSelectedStar(value)}} className="vehicleWriteReviewPage_rating_starIcon cursorPointer">
    //                                                 <IconStar color={value <= seletedStar ? "#FFC327" : undefined} />
    //                                             </div>
    //                                         )
    //                                         return result
    //                                     },[])
    //                                 }
    //                             </div>
    //                         </div>
    //                         <div className="vehicleWriteReviewPage_rating tyreWriteReview_extra">
    //                             <div className="tyreWriteReview_inner">
    //                                 <div className="tyreWriteReview_grid">
    //                                     <div className="tyreWriteReview_grid_inner">
    //                                         <span className="fontSize_12 fontWeight_medium">Dry grip and braking</span>
    //                                         <span style={{ display: 'flex' }}>
    //                                             {
    //                                                 _.reduce([1,2,3,4,5], (result1, value1, key1)=>{
    //                                                     result1.push(
    //                                                         <div key={key1} onClick={()=>{setSelectedDryGrip(value1)}} className="vehicleWriteReviewPage_rating_starIcon cursorPointer tyreWriteReview_rating_star">
    //                                                             <IconStar color={value1 <= selectedDryGrip ? "#FFC327" : undefined} />
    //                                                         </div>
    //                                                     )
    //                                                     return result1
    //                                                 },[])
    //                                             }
    //                                         </span>
    //                                     </div>
    //                                     <div className="tyreWriteReview_grid_inner">
    //                                         <span className="fontSize_12 fontWeight_medium">Wet grip and braking</span>
    //                                         <span style={{ display: 'flex' }}>
    //                                             {
    //                                                 _.reduce([1,2,3,4,5], (result2, value2, key2)=>{
    //                                                     result2.push(
    //                                                         <div key={key2} onClick={()=>{setSelectedWetGrip(value2)}} className="vehicleWriteReviewPage_rating_starIcon cursorPointer tyreWriteReview_rating_star">
    //                                                             <IconStar color={value2 <= selectedWetGrip ? "#FFC327" : undefined} />
    //                                                         </div>
    //                                                     )
    //                                                     return result2
    //                                                 },[])
    //                                             }
    //                                         </span>
    //                                     </div>
    //                                 </div>
    //                                 <div className="tyreWriteReview_grid">
    //                                     <div className="tyreWriteReview_grid_inner">
    //                                         <span className="fontSize_12 fontWeight_medium">Longevity</span>
    //                                         <span style={{ display: 'flex' }}>
    //                                             {
    //                                                 _.reduce([1,2,3,4,5], (result3, value3, key3)=>{
    //                                                     result3.push(
    //                                                         <div key={key3} onClick={()=>{setSelectedLongevity(value3)}} className="vehicleWriteReviewPage_rating_starIcon cursorPointer tyreWriteReview_rating_star">
    //                                                             <IconStar color={value3 <= selectedLongevity ? "#FFC327" : undefined} />
    //                                                         </div>
    //                                                     )
    //                                                     return result3
    //                                                 },[])
    //                                             }
    //                                         </span>
    //                                     </div>
    //                                     <div className="tyreWriteReview_grid_inner">
    //                                         <span className="fontSize_12 fontWeight_medium">Silence and Comfort</span>
    //                                         <span style={{ display: 'flex' }}>
    //                                             {
    //                                                 _.reduce([1,2,3,4,5], (result4, value4, key4)=>{
    //                                                     result4.push(
    //                                                         <div key={key4} onClick={()=>{setSelectedSilenceComfort(value4)}} className="vehicleWriteReviewPage_rating_starIcon cursorPointer tyreWriteReview_rating_star">
    //                                                             <IconStar color={value4 <= selectedSilenceComfort ? "#FFC327" : undefined} />
    //                                                         </div>
    //                                                     )
    //                                                     return result4
    //                                                 },[])
    //                                             }
    //                                         </span>
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                     <div className="vehicleWriteReviewPage_writeReviewContainer">
    //                         <p className="fontSize_14 fontWeight_bold">
    //                             {t('write_a_review')}
    //                         </p>
    //                         <div className="vehicleWriteReviewPage_textareaContainer"> 
    //                             <Textarea 
    //                                 minRows={7}
    //                                 maxRows={7}
    //                                 maxLength={100}
    //                                 placeholder={t('what_do_you_think_of_the_quality_and_appearance')}
    //                                 classNames={{
    //                                     input: "vehicleWriteReviewPage_textarea_input fontSize_14",
    //                                     error: "fontSize_14 fontColor_red"
    //                                 }}
    //                                 {...getInputProps('review')}
    //                             />
    //                             <div className="vehicleWriteReviewPage_textarea_totalNumBox">
    //                                 <p className="fontSize_14 fontColor_lightGrey3">
    //                                     {`${values?.review.length} / 100`}
    //                                 </p>
    //                             </div>
    //                         </div>
    //                     </div>
    //                     <button type="submit" disabled={isValid() ? false : true} className="vehicleWriteReviewPage_submitButton primaryButtonBackground">
    //                         <p className="fontSize_16 fontWeight_bold fontColor_white">
    //                             {t('submit')}
    //                         </p>
    //                     </button>
    //                 </form>
    //             </div>
    //         </div>
    //     </>
    // )
}